module.exports = __webpack_public_path__ + "img/064.5a14a4c3.png";